import React from 'react';
import { IonContent, IonRow, IonCol } from '@ionic/react';
import './styles/Home.scss';

const Home = () => {
  return (
    <IonContent fullscreen scrollY={false} id='home'>
      <IonRow className='ion-align-items-center ion-justify-content-center section play '>
        <IonCol className='ion-hide-md-up ion-text-center' size='12'>
          <h1 style={{ fontSize: '12vw' }}>PLAY.</h1>
        </IonCol>

        <IonCol className='ion-hide-md-down' size='4' offset='1'>
          <h1 style={{ fontSize: '8vw' }}>PLAY.</h1>
        </IonCol>
        <IonCol size='6' className='ion-hide-md-down'>
          <p>
            Have fun with your friends as you embark the journey of gaining technical skills together. Build rivalry by
            pushing yourself to the limits. Balance fun and learning with your squad. Replace gaming nights with coding
            nights. If RedBull doesn't give you wings, the errors will!!!
          </p>
        </IonCol>
      </IonRow>

      <IonRow className='ion-align-items-center ion-justify-content-center section practice'>
        <IonCol className='ion-hide-md-up ion-text-center mobile' size='12'>
          <h1 style={{ fontSize: '12vw' }}>PRACTICE.</h1>
        </IonCol>

        <IonCol size='4' offset='1' className='ion-hide-md-down'>
          <p>
            The place to practice your coding skills. Develop your cognitive thinking and pattern recognition skills, be
            ahead of the pack, gain knowledge and have fun at the same time.
          </p>
        </IonCol>
        <IonCol size='6' offset='1' className='ion-hide-md-down'>
          <h1 style={{ fontSize: '7vw' }}>PRACTICE.</h1>
        </IonCol>
      </IonRow>

      <IonRow className='ion-align-items-center ion-justify-content-center section progress'>
        <IonCol className='ion-hide-md-up ion-text-center mobile' size='12'>
          <h1 style={{ fontSize: '12vw' }}>PROGRESS.</h1>
        </IonCol>

        <IonCol size='6' offset='1' className='ion-hide-md-down'>
          <h1 style={{ fontSize: '7vw' }}>PROGRESS.</h1>
        </IonCol>
        <IonCol size='4' className='ion-hide-md-down'>
          <p>
            Don't rest until you've improved, keep track of your achievements and failures, target your weak spots,
            analyse, improvise, adapt and overcome.
          </p>
        </IonCol>
      </IonRow>
    </IonContent>
  );
};

export default Home;
